import shop from '../../api/shop'
import * as types from '../mutation-types'

// initial state
const state = {
  all: [],
  categories: [],
  forCustomer: '',
}

// getters
const getters = {
  allProducts: state => state.all,
  categories: state => state.categories
}

// actions
const actions = {
  getAllProducts ({ commit, state }) {
    shop.getProducts(state.forCustomer, data => {
      let products = []
      data.data.forEach(e => {
        products = products.concat(e.products)
      })
      commit(types.RECEIVE_PRODUCTS, { products })
      commit(types.RECEIVE_CATEGORIES, { categories: data.data })
    })
  },
  setForCustomer({ commit, state }, forCustomer) {
    commit(types.SET_FOR_CUSTOMER, { forCustomer })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_PRODUCTS] (state, { products }) {
    state.all = products
  },
  [types.RECEIVE_CATEGORIES] (state, { categories }) {
    state.categories = categories
  },
  [types.SET_FOR_CUSTOMER] (state, { forCustomer }) {
    state.forCustomer = forCustomer
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js